import { render, staticRenderFns } from "./AddTrainingDocument.vue?vue&type=template&id=a9befcdc"
import script from "./AddTrainingDocument.vue?vue&type=script&lang=js"
export * from "./AddTrainingDocument.vue?vue&type=script&lang=js"
import style0 from "./AddTrainingDocument.vue?vue&type=style&index=0&id=a9befcdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports